import * as z from "zod/v4";

const cancelOrderSelfServeInput = z.object({
  orderIdOrOrderNoOrConfirmationNo: z
    .string()
    .describe("The order number, ID, or confirmation number to cancel"),
  customerEmail: z
    .string()
    .describe("Customer's email address for verification"),
});

const cancelOrderSelfServeOutput = z.object({
  success: z.boolean(),
  orderNumber: z.string(),
  error: z.string().optional(),
  cancellationDetails: z
    .object({
      cancelledAt: z.string().datetime(),
      notificationSent: z.boolean(),
    })
    .optional(),
  refundDetails: z
    .object({
      amount: z.number(),
      currency: z.string(),
      processedAt: z.string().datetime().optional(),
    })
    .optional(),
});

export const cancelOrderSelfServe = {
  name: "cancelOrderSelfServe" as const,
  input: cancelOrderSelfServeInput,
  output: cancelOrderSelfServeOutput,
};
